window.generalLoaded = true;
window.dispatchEvent(new CustomEvent('generalLoaded'));
